module.exports = __webpack_public_path__ + "img/tz.6a109b2f.jpg";